import React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H2Emphasized,
    YStack,
} from 'smoothie';

import { CardForm } from '../../../types/Card';
import FruitfulCard from '../../cards/FruitfulCard';

export const PhysicalCardSent = ({
    embossName,
    onPress,
}: {
    embossName: string;
    onPress: () => void;
}) => {
    return (
        <YStack flex={1} justifyContent="space-between">
            <YStack alignItems="center">
                <FruitfulCard
                    marginVertical={40}
                    cardholderName={embossName}
                    form={CardForm.PHYSICAL}
                    width={316}
                />

                <H2Emphasized textAlign="center">
                    Your physical card is on{'\n'} the way!
                </H2Emphasized>
                <BodyMediumRegular
                    color="$gray1000"
                    textAlign="center"
                    whiteSpace="pre-wrap"
                >
                    You should get it in 5-7 business days.
                </BodyMediumRegular>
            </YStack>
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Done"
                onPress={onPress}
            />
        </YStack>
    );
};
